import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Category, Contact, ContactService } from '@fgb/core';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit, OnDestroy {
  contactUsForm: UntypedFormGroup;
  categories$: Observable<Category[]>;
  submitted = false;
  sentSuccessfully: boolean = false;

  private readonly _subscription = new Subscription();

  constructor(private formBuilder: UntypedFormBuilder, private contactService: ContactService) {}

  get f() {
    return this.contactUsForm.controls;
  }

  ngOnInit() {
    this.categories$ = this.contactService.getCategories();

    this.initForm();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  async submit(message: Contact, isValid: boolean) {
    this.submitted = true;
    if (isValid) {
      await this.contactService.sendMessage(message);
      this.sentSuccessfully = true;
    }
  }

  public initForm(): void {
    this.contactUsForm = this.formBuilder.group({
      category: [''],
      message: ['', [Validators.required, this.noWhitespaceValidator, this.invalidTagsValidator, this.profanityFilterValidator]],
    });

    this.watchMessage(this.contactUsForm);
    this.watchCategories(this.contactUsForm);
  }

  public watchCategories(fg: UntypedFormGroup): void {
    this._subscription.add(
      this.categories$.pipe(take(1)).subscribe((cats) => {
        if (cats.length) {
          fg.controls.category.setValue(cats[0].Name);
        }
      })
    );
  }

  public watchMessage(fg: UntypedFormGroup): void {
    this._subscription.add(
      fg?.get('message')?.valueChanges.subscribe((content: string) => {
        this.sentSuccessfully = false;
      })
    );
  }

  public noWhitespaceValidator(control: UntypedFormControl) {
    if (control.value === '') return;
    return control.value.trim().length ? null : { whitespace: true };
  }

  public invalidTagsValidator(control: UntypedFormControl) {
    if (control.value === '') return;
    var rgx = /<\/?script|<\/?a/gi;
    return rgx.test(control.value) ? { invalidTags: true } : null;
  }

  public profanityFilterValidator(control: UntypedFormControl) {
    if (control.value === '') return;
    //list of profanity words
    let profanityWords: string[] = [];
    //list of filtered profanity words
    let filteredProfanityWords: string[] = [];
    profanityWords.forEach((word) =>
      control.value.replace(/ /g, '').toLowerCase().includes(word.replace(/ /g, '').toLowerCase())
        ? filteredProfanityWords.push(word)
        : null
    );
    return filteredProfanityWords.length ? { profanityFilter: true } : null;
  }
}
